// generated by tools/extract_assets.py - do not edit
export const CAR_VIEWBOX = "0 0 198.000000 513.000000";
export const CAR_PATH = `<metadata>
Created by potrace 1.16, written by Peter Selinger 2001-2019
</metadata>
<g transform="translate(0.000000,513.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M565 5119 c-316 -8 -339 -11 -374 -38 -21 -16 -26 -35 -47 -197 -47
-365 -67 -576 -55 -583 8 -5 5 -65 -9 -221 -25 -284 -38 -506 -47 -796 -5
-200 -9 -241 -22 -252 -14 -12 -14 -13 1 -8 45 14 117 17 137 7 28 -15 18 -31
-19 -31 -23 0 -30 -5 -35 -29 -6 -29 -26 -41 -72 -41 -13 0 -23 -4 -23 -10 0
-5 6 -10 14 -10 12 0 13 -46 9 -300 -5 -223 -3 -300 5 -300 9 0 12 81 12 305
l0 306 29 5 c23 5 31 13 36 35 18 82 25 3 27 -313 l3 -343 2 313 3 312 38 0
c37 0 37 -1 66 -72 85 -213 87 -223 96 -393 l8 -160 -3 160 c-3 181 -8 200
-110 445 -31 74 -64 155 -73 179 -10 26 -36 61 -66 88 l-49 44 7 202 c13 364
65 976 122 1425 22 174 24 203 10 195 -6 -3 -7 -2 -3 2 8 9 23 14 75 22 25 4
32 2 32 -11 0 -9 -8 -16 -20 -16 -25 0 -70 -21 -70 -32 0 -5 13 -2 30 7 43 22
60 19 60 -10 0 -15 -16 -187 -35 -383 -30 -310 -84 -1124 -86 -1303 -1 -55 8
-84 102 -312 56 -139 107 -258 112 -264 14 -19 54 -16 169 13 248 61 477 62
735 3 205 -47 177 -69 301 231 l106 255 -2 115 c-4 199 -51 880 -87 1256 -19
199 -35 373 -35 388 0 31 27 35 65 10 14 -9 25 -12 25 -7 0 13 -45 33 -75 33
-16 0 -25 6 -25 15 0 17 55 21 80 5 9 -6 17 -5 21 1 4 7 9 4 12 -6 4 -9 3 -14
-2 -11 -11 7 -7 -45 19 -224 47 -335 96 -931 116 -1427 l7 -172 -50 -48 c-33
-31 -58 -67 -73 -103 -12 -30 -47 -116 -77 -190 -104 -252 -96 -187 -100 -835
-3 -397 -1 -594 7 -649 6 -44 32 -145 57 -225 62 -195 85 -211 122 -82 17 56
21 119 30 431 6 201 11 376 11 388 0 21 -3 22 -110 22 -86 0 -110 3 -110 13 0
11 30 15 128 20 70 3 136 9 146 13 19 7 19 0 12 -283 -5 -239 -32 -823 -62
-1343 -3 -58 -11 -118 -17 -135 -22 -62 -69 -104 -114 -105 l-23 0 -1 248 0
247 -47 280 c-43 253 -50 281 -70 291 -16 8 -55 5 -164 -14 -207 -35 -531 -36
-733 -3 -154 26 -182 28 -195 15 -5 -5 -32 -144 -59 -309 -51 -300 -51 -301
-51 -528 0 -247 2 -237 -57 -217 -31 11 -65 50 -76 85 -12 37 -77 1170 -77
1328 0 42 -4 67 -11 67 -12 0 -9 -97 20 -605 14 -239 15 -302 5 -310 -16 -14
10 -442 31 -500 19 -51 65 -100 107 -114 62 -20 334 -52 526 -62 274 -15 596
5 869 52 52 9 72 18 103 48 23 22 42 51 48 76 16 62 41 487 30 505 -6 10 -4
117 6 300 9 157 21 461 28 675 6 215 15 395 20 402 14 17 12 183 -1 196 -8 8
-11 114 -11 333 l0 321 43 -8 c23 -4 57 -8 75 -9 28 0 32 3 32 25 0 32 -37 67
-101 97 l-48 23 -1 106 c0 169 -20 543 -44 855 -14 185 -19 291 -13 296 12 7
-11 252 -50 541 -30 226 -40 252 -100 261 -42 7 -638 27 -718 24 -27 0 -180
-5 -340 -9z m493 -16 c-71 -2 -185 -2 -255 0 -71 1 -13 3 127 3 140 0 198 -2
128 -3z m-633 -14 c-88 -4 -173 -10 -188 -12 -15 -2 -24 0 -20 4 10 10 94 15
248 16 118 0 117 0 -40 -8z m1217 -7 c5 -5 -4 -7 -19 -5 -15 2 -100 8 -188 13
l-160 9 179 -4 c99 -3 183 -8 188 -13z m-402 -7 c14 -17 35 -21 25 -5 -4 6 32
10 102 10 130 0 183 -8 183 -26 0 -11 -26 -14 -123 -14 -68 0 -126 2 -129 5
-3 3 -169 6 -368 6 -199 0 -365 -3 -368 -6 -3 -3 -63 -5 -134 -5 -101 0 -128
3 -128 14 0 17 64 26 197 26 67 0 102 -4 98 -10 -10 -16 11 -12 25 5 11 13 58
15 310 15 252 0 299 -2 310 -15z m38 -44 c10 -6 31 -192 77 -677 35 -368 67
-690 70 -716 l6 -48 -50 20 c-203 80 -681 80 -899 -1 l-54 -19 6 37 c3 21 35
342 71 713 37 371 68 681 70 688 3 9 82 12 347 12 189 0 349 -4 356 -9z m-718
-22 c0 -27 -140 -1422 -143 -1424 -1 -1 -22 -10 -47 -19 -25 -10 -74 -33 -109
-52 -36 -18 -67 -31 -70 -29 -15 16 93 1463 114 1533 3 9 38 12 130 12 120 0
125 -1 125 -21z m1032 -364 c32 -337 92 -1155 84 -1162 -2 -2 -55 22 -119 52
l-115 56 -6 47 c-4 26 -33 331 -66 677 -33 347 -62 649 -65 673 l-6 43 128 -3
128 -3 37 -380z m125 88 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0
-35z m-1570 -25 c-2 -13 -4 -5 -4 17 -1 22 1 32 4 23 2 -10 2 -28 0 -40z
m1580 -50 c-2 -13 -4 -5 -4 17 -1 22 1 32 4 23 2 -10 2 -28 0 -40z m-1603
-167 c-9 -100 -21 -181 -26 -181 -5 0 -7 8 -4 18 2 9 12 92 22 185 9 92 19
165 22 163 2 -3 -4 -86 -14 -185z m1613 77 c-2 -13 -4 -5 -4 17 -1 22 1 32 4
23 2 -10 2 -28 0 -40z m10 -100 c-2 -13 -4 -3 -4 22 0 25 2 35 4 23 2 -13 2
-33 0 -45z m10 -90 c-2 -13 -4 -5 -4 17 -1 22 1 32 4 23 2 -10 2 -28 0 -40z
m-553 -738 c132 -23 266 -70 391 -137 l85 -45 0 -51 0 -50 -23 21 c-13 12 -44
29 -70 38 -26 9 -47 22 -47 30 0 10 -12 14 -41 14 -22 0 -102 13 -177 29 -164
35 -362 53 -492 45 -111 -7 -312 -44 -425 -79 -44 -14 -92 -25 -107 -25 -16 0
-28 -4 -28 -10 0 -5 -5 -10 -11 -10 -6 0 -26 -12 -45 -26 l-34 -26 0 51 0 51
98 48 c233 116 376 149 643 151 126 1 195 -4 283 -19z m-119 -125 c83 -8 193
-26 245 -39 l95 -24 -287 -1 c-286 -1 -373 -12 -195 -25 126 -9 288 -9 433 0
109 6 127 5 187 -15 66 -22 108 -57 122 -100 8 -25 -15 -89 -123 -351 -76
-185 -92 -215 -111 -218 -13 -2 -82 10 -155 26 -196 45 -339 56 -511 37 -77
-8 -185 -26 -240 -40 -163 -40 -136 -65 -259 236 -60 149 -106 275 -106 293 0
18 9 44 19 58 34 42 85 56 262 68 158 10 475 52 487 64 3 3 3 8 0 11 -4 4
-300 -25 -493 -49 -35 -5 -37 -4 -15 5 47 20 255 61 345 69 138 11 140 11 300
-5z m-317 -52 c-10 -2 -26 -2 -35 0 -10 3 -2 5 17 5 19 0 27 -2 18 -5z m-93
-13 c-22 -4 -80 -10 -130 -13 l-90 -6 90 13 c50 7 108 13 130 13 l40 1 -40 -8z
m583 -17 c-54 -2 -142 -2 -195 0 -54 1 -10 3 97 3 107 0 151 -2 98 -3z m-1154
-280 c26 -28 36 -46 36 -70 0 -29 -3 -33 -27 -33 -16 0 -38 -3 -50 -6 -21 -6
-23 -3 -23 32 0 53 11 114 20 114 4 0 24 -17 44 -37z m1710 0 c3 -21 6 -55 6
-77 0 -31 -3 -37 -16 -32 -9 3 -29 6 -45 6 -27 0 -29 3 -29 38 0 29 7 46 31
70 17 18 35 32 39 32 4 0 10 -17 14 -37z m-94 -77 c0 -13 -6 -26 -14 -29 -11
-5 -12 0 -3 24 14 35 17 36 17 5z m145 -62 c48 -23 111 -82 99 -93 -5 -5 -46
-3 -94 5 -83 13 -110 28 -110 61 0 7 -11 13 -24 13 -26 0 -41 14 -31 30 9 14
119 4 160 -16z m-1667 -46 c11 -27 11 -28 -23 -28 -29 0 -35 4 -35 21 0 22 31
53 41 41 3 -4 10 -19 17 -34z m1522 -5 c0 -20 -5 -23 -36 -23 -19 0 -33 4 -30
9 3 4 10 20 16 35 9 23 12 25 30 14 11 -7 20 -23 20 -35z m38 -2 c6 -18 20
-31 36 -35 l27 -7 -5 -332 c-3 -182 -7 -359 -8 -392 -2 -33 1 -92 5 -131 l9
-71 -29 -7 c-15 -3 -83 -9 -150 -12 -109 -6 -123 -5 -123 9 0 14 16 17 108 19
l107 3 -1 493 c-1 270 2 492 6 492 4 0 13 -13 18 -29z m-33 -223 c3 -106 5
-312 3 -458 l-3 -265 -103 -3 -104 -3 4 298 c5 329 3 318 81 515 l42 108 36 0
37 0 7 -192z m92 -565 c-2 -16 -4 -5 -4 22 0 28 2 40 4 28 2 -13 2 -35 0 -50z
m-87 -272 c0 -10 -5 -180 -10 -377 -10 -316 -13 -368 -32 -432 -30 -105 -43
-96 -95 68 -66 207 -73 259 -73 526 l0 234 105 0 c96 0 105 -2 105 -19z
m-1160 -753 c189 -32 518 -32 728 2 110 17 158 21 170 14 12 -8 28 -80 65
-298 43 -250 47 -290 35 -302 -8 -9 -88 -28 -184 -45 -163 -30 -180 -31 -454
-31 -274 0 -292 2 -453 31 -92 17 -172 33 -177 36 -6 3 -10 1 -10 -4 0 -6 2
-11 5 -11 3 0 83 -14 178 -31 167 -30 180 -31 462 -31 282 0 295 1 459 31 93
18 173 34 177 37 5 3 9 -96 9 -219 l0 -224 -137 -18 c-340 -45 -686 -45 -1027
1 l-138 18 5 260 c4 256 5 266 51 521 25 143 48 266 51 273 6 17 41 15 185
-10z m-465 -699 c17 -249 20 -266 49 -297 36 -40 69 -51 227 -73 364 -50 725
-50 1096 0 186 25 225 42 260 119 l12 27 -5 -30 c-8 -40 -72 -101 -120 -114
-22 -5 -115 -20 -209 -33 -147 -19 -212 -22 -480 -22 -263 0 -337 4 -485 23
-96 12 -192 27 -212 32 -47 12 -97 54 -114 96 -17 39 -54 506 -39 491 3 -2 12
-101 20 -219z m1672 144 c-2 -16 -4 -3 -4 27 0 30 2 43 4 28 2 -16 2 -40 0
-55z m-10 -145 c-2 -18 -4 -6 -4 27 0 33 2 48 4 33 2 -15 2 -42 0 -60z m-10
-150 c-2 -18 -4 -6 -4 27 0 33 2 48 4 33 2 -15 2 -42 0 -60z"/>
<path d="M132 1545 c-1 -33 3 -141 8 -240 10 -210 30 -290 70 -290 21 0 28 13
62 115 65 193 78 253 76 370 l-1 105 -7 -125 c-6 -115 -11 -138 -62 -290 -34
-105 -59 -165 -68 -165 -7 0 -22 25 -32 55 -15 43 -22 101 -29 265 -10 230
-15 292 -17 200z"/>
</g>`;
